export const CS_STATUS_ONLINE = 'ONLINE'
export const CS_STATUS_OFFLINE = 'OFFLINE'
export const CS_STATUS_HEARTBEAT = 'HEARTBEAT'

export const list = [
    CS_STATUS_ONLINE,
    CS_STATUS_OFFLINE,
    CS_STATUS_HEARTBEAT,
]